import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a1a24] pt-10 pb-6 border-t border-white/5" data-id="element-152">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="text-center mb-6" data-id="element-154">
          <h2 className="text-xl font-display font-black text-white mb-2" data-id="element-155">
            🧘 STRETCHING RESUELTO™
          </h2>
          <p className="text-gray-400 text-sm max-w-2xl mx-auto" data-id="element-156">
            El sistema de clases N°1 para profes de Stretching en Argentina.
            Porque enseñar Stretching no debería costarte todas las noches de la
            semana.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-6 text-sm" data-id="element-157">
          <a href="mailto:contacto@recursosfitness.shop" className="flex items-center text-gray-300 hover:text-brand-accent transition-colors" data-id="element-158">
            <Mail className="w-4 h-4 mr-1.5" data-id="element-159" /> contacto@recursosfitness.shop
          </a>
          <a href="#" className="flex items-center text-gray-300 hover:text-brand-accent transition-colors" data-id="element-160">
            @recursosfitness.ar
          </a>
          <a href="https://recursosfitness.shop" className="flex items-center text-gray-300 hover:text-brand-accent transition-colors" data-id="element-161">
            <Globe className="w-4 h-4 mr-1.5" data-id="element-162" /> recursosfitness.shop
          </a>
        </div>

        <div className="text-center text-gray-500 text-xs border-t border-white/5 pt-5" data-id="element-163">
          © RecursosFitness.shop™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
}